/* eslint-disable camelcase */

import _ from 'underscore';

import { BreadcrumbsTypes } from 'root/breadcrumbs';

class SingleTab implements MerchantosSingleTab {
  name: string;

  evalcode: string;

  title: string;

  reloads: string[];

  constructor(name: string) {
    this.name = name;
    this.evalcode = '';
    this.title = '';
    this.reloads = [];
  }

  open = (forceReload: boolean = false) => {
    $('#loading').hide();

    if (forceReload) {
      return this.reload(true);
    }

    if ($(`#section .${this.name}`).length > 0) {
      this.show();
      return true;
    }

    return this.reload(true);
  };

  /**
   * Pull the tab's html and add it to the dom
   * @param showWhenLoaded display tab when the new html is available
   */
  reload = (showWhenLoaded: boolean = false): boolean => {
    window.abortFooterTabOpen = true;

    const contentMap = {} as ContentMap;
    contentMap.form_name = 'tab.open';
    contentMap.name = this.name;

    window.doServerCall(contentMap, (result) => this.insertHtmlInPage(result, showWhenLoaded));
    return true;
  };

  private insertHtmlInPage(result: AjaxFormsResponse, showWhenLoaded: boolean = true) {
    if (!result.name || !result.html) {
      return;
    }

    window.merchantos.page.show('section', { html: result.html, container_class: this.name });

    $('kbd').each((_i, el) => {
      const shortcut = el.innerText.toLowerCase();

      if (window.merchantos.keyboard.permanent_keys[shortcut]) return;

      window.merchantos.keyboard.unsubscribe(shortcut);
      window.merchantos.keyboard.subscribe(shortcut, () => $(el).trigger('click'));
    });

    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    this.evalcode = result.evalcode;

    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    this.title = result.title;
    this.reloads = [];

    // Make sure the tab ui is reloaded but doesnt disappear or replace the current tab
    if (showWhenLoaded || window.merchantos.tabs.currentTab === this.name) {
      this.show();
    } else {
      this.close();
    }
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string[] | undefined' is not assignable to t... Remove this comment to see the full error message
    this.reloads = result.reloads;
  }

  show = () => {
    window.clearParents();
    const crumb_title = this.title ? this.title : this.name.toCapitalize();
    window.setCrumbs([window.crumbItem(crumb_title, this.name, BreadcrumbsTypes.UiTab)]);
    window.setLinkTo(`/?form_name=ui_tab&tab=${this.name}`, this.name.toCapitalize());

    const parent_obj = {
      type: BreadcrumbsTypes.UiTab,
      title: crumb_title,
      name: this.name,
    };
    if (!window.breadcrumbs) {
      window.breadcrumbs = [];
    }
    window.breadcrumbs.push(parent_obj);

    // save views if nec.
    const tab_holder = $('#section');
    if (tab_holder) {
      tab_holder.hide();
    }

    window.saveOnChanges().done(
      _.bind(() => {
        if (tab_holder) {
          tab_holder.show();
        }

        // hide other content
        $('#main').hide();

        // close current
        if (window.merchantos.tabs.currentTab) {
          window.merchantos.tabs.getTab(window.merchantos.tabs.currentTab).close();
        }

        // Clear all the tab saved data, will refetch newest on navigate
        window.clearViewTabs();

        // Undo advancedReporting modifications unless viewing advanced reporting.
        if (window.location.href.indexOf('roll_up') === -1) {
          window.hideAdvancedReporting();
        }

        // show the tab content
        $(`#${this.name}_tab`).show();

        // listen for click events on any date inputs.
        window.merchantos.datepicker.init();

        window.merchantos.tabs.setCurrent(this.name);

        // load any listings after a short delay
        setTimeout(() => {
          window.autoLoadListings(`${this.name}_tab`, false);
          window.popQueueRequestAndProcess(`${this.name}_tab`);
        }, 100);

        // auto focus on any auto focus fields
        $(`#${this.name}_tab`).find('.autofocus').first().trigger('select');

        // reload any sections that need to be loaded on every show()
        $.each(this.reloads, (_i, sectionname) => window.merchantos.sections.open(sectionname));

        return true;
      }, this)
    );
  };

  close = () => {
    $(`#${this.name}_tab`).hide();
  };
}

type TabName = string;
type Tabs = { [name: TabName]: MerchantosSingleTab };

class NavigationTabs implements MerchantosTabs {
  currentTab: string;

  previousTab: string;

  tabs: Tabs;

  constructor() {
    this.currentTab = '';
    this.previousTab = '';
    this.tabs = {};
  }

  getTab = (name: TabName): MerchantosSingleTab => {
    if (!this.tabs[name]) {
      // eslint-disable-next-line new-cap
      this.tabs[name] = new SingleTab(name);
    }
    return this.tabs[name];
  };

  show = (name: TabName) => {
    if (this.tabs[name]) {
      window.merchantos.page.show('section');
    }
    const tab = this.getTab(name);
    tab.open();
  };

  close = () => {
    // if there is no currently open tab then do nothing
    if (!this.currentTab) {
      return;
    }

    // restore clobbered keys
    window.merchantos.keyboard.restore();

    // wipe out the current tab if there is one
    $(`#${this.currentTab}_tab`).hide();

    this.currentTab = '';
  };

  setCurrent = (name: TSFixMe) => {
    if (this.currentTab === name) return;

    let node;

    // unhighlight current tab
    if (this.currentTab) {
      // if the current tab has a tab then unhighlight it
      $(`#__tab_${this.currentTab}`).removeClass('current');
    }

    this.previousTab = this.currentTab;
    this.currentTab = name;

    // make this the highlighted tab
    node = $(`#__tab_${this.currentTab}`)[0];
    node = $(node).addClass('current');

    node.trigger('focus');
  };
}

window.merchantos.tabs = new NavigationTabs();
